if (!customElements.get("classroom-details")) {
    class ClassroomDetails extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const video = this.querySelector("[data-plyr-video]");
            if (!video) return; // no video found
            this.addEventListener("custom-dialog:open", () => {
                if (video.readyState >= 3) {
                    video.play();
                } else {
                    video.addEventListener('canplay', () => video.play(), { once: true });
                }
            });

            this.addEventListener("custom-dialog:close", () => {
                video.pause();
            });
        }

        disconnectedCallback() {
        }
    }

    customElements.define('classroom-details', ClassroomDetails);
}
